import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './MenuTitle.scss';

function MenuTitle(props) {
    const {
        greetingClassName = '',
        isLoggedIn = false,
        userFirstName = '',
        t,
    } = props;

    if (isLoggedIn) {
        return (
            <span
                className={classNames(styles.greeting, greetingClassName)}
            >
                {t('informal-greeting-name', {
                    firstname: userFirstName,
                })}
            </span>
        );
    }

    return (
        <span>
            {t('log-in')}
        </span>
    );
}

MenuTitle.propTypes = {
    greetingClassName: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    t: PropTypes.func.isRequired,
    userFirstName: PropTypes.string,
};

export { MenuTitle };
export default localize(MenuTitle, ['t'], baseAppConfig.namespace);
